const gray = {
  900: "#222222", // Main Text
  800: "#313131",
  700: "#37414A",
  650: "#898989",
  600: "#7D879C",
  550: "#e5e5e5",
  500: "#C9C9C9", //Border Color
  400: "#F6F7FB",
  350: "#a0a0a0",
  300: "#E3E9EF",
  200: "#F3F5F9",
  100: "#F6F9FC",
  white: "#FFFFFF",
};

const textColor = {
  primary: gray[900],
  secondary: gray[800],
  hint: gray[600],
  muted: gray[600],
  disabled: gray[400],
  link: "#0095ed",
};

const bodyColor = {
  text: textColor.primary,
  default: gray[100],
  paper: gray["white"],
};

const primaryColor = {
  pink: "#EF3B62",
  green: "#19A057",
  blue: "#0095ee",

  main: "#EF3625",

  second: "#37414A",

  middle: "#F4C521",
  dark: "#E70012",
  light: "#EF3625",
  moreLight: "rgba(233,81,6,.7)",

  text: "#ffffff",

  yellow: "#ffff00",
  navy: "#056bb8",
};

const gradientColor = {
  100: "linear-gradient(87.4deg, #EF90A1 1.33%, #F1A38E 11.26%, #F5C288 21.24%, #F6CC6E 30.68%, #E9D553 42.3%, #CAD855 53.54%, #A0E15C 63.4%, #93DC71 73.03%, #7ECDD3 83.24%, #A1B5F5 89.02%, #AAA2F0 96.86%)",
  200: "linear-gradient(92.53deg, rgba(255, 237, 118, 0.7) 3.23%, rgba(202, 181, 0, 0.7) 31.41%, rgba(182, 165, 0, 0.7) 64.84%, rgba(143, 129, 1, 0.7) 98.75%), linear-gradient(88.18deg, #857A03 0.52%, #B3A201 12.35%, #CAB500 22.69%, #E1C901 33.04%, #8F8101 48.31%, #857900 61.12%, #8C7F01 77.87%, #968801 94.13%)",
  300: "linear-gradient(90deg, #FA6268 0%, #F4C521 100%)",
  400: "linear-gradient(90deg, #725DDF 0%, #84B5D3 100%)",
  500: "linear-gradient(90deg, #FF6C00 0%, #FF6C00 100%)",
  text: "#ffffff",
};

const secondaryColor = {
  light: "rgba(15, 52, 96, 0.2)",
  main: "#0F3460",
  second: "#FF6C00",
  dark: "#303A47",
  text: "#ffffff",
  900: "#041533",
  100: "#F3F6F9",
};

const warningColor = {
  main: "#F4C521",
  text: textColor.primary,
};
const errorColor = {
  main: "#E70012",
  light: "#FFE1E6",
  text: textColor.primary,
};
const successColor = {
  main: "rgba(51, 208, 103, 1)",
  light: "rgba(51, 208, 103, 0.15)",
  text: textColor.primary,
};
const defaultColor = {
  light: textColor.secondary,
  main: textColor.primary,
  dark: textColor.primary,
  text: textColor.primary,
};

export const colors = {
  default: defaultColor,
  primary: primaryColor,
  gradient: gradientColor,
  secondary: secondaryColor,
  warn: warningColor,
  error: errorColor,
  success: successColor,
  text: textColor,
  body: bodyColor,
  gray,
};
